import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import { useAPI } from "../../../../lib/common";
import AppBar from "../../Components/AppBar";
import { EditUserName, } from "@/react/Webshop/Desktop/Pages/MyAccount/Components/ChangeUserName";
export default () => {
    const [data, loading] = useAPI("/sections/my-account/ajax/get_account_data.php");
    if (loading) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Fetching account settings")));
    }
    const { userInfo } = data;
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Change username")),
        React.createElement(Container, { maxWidth: "xs" },
            React.createElement(Card, null,
                React.createElement(CardContent, null,
                    React.createElement(EditUserName, { userName: userInfo.username }))))));
};
